/* unplugin-vue-components disabled */import { render } from "./ShareModal.vue?vue&type=template&id=56da7650&scoped=true&ts=true"
import script from "./ShareModal.vue?vue&type=script&lang=ts"
export * from "./ShareModal.vue?vue&type=script&lang=ts"

import "./ShareModal.vue?vue&type=style&index=0&id=56da7650&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56da7650"]])

export default __exports__